import { useEffect, useRef } from 'react';
import Button from '~/components/Button';
import { Input } from '~/components/form';
import inputStyles from '~/components/form/Input.module.css';
import { Form, useActionData, type V2_MetaFunction } from '~/remix';
import { useUser } from '~/utils';
import { getErrors, getSuccess } from '~/utils/data';
import { action } from './_route.server';
export { action };

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Contact' },
];

export let links = () => [{ rel: 'stylesheet', href: inputStyles }];

export default function () {
  const user = useUser();
  const data = useActionData<typeof action>();
  const errors = getErrors(data);
  const { message } = getSuccess(data);

  const nameRef = useRef<HTMLInputElement>(null);
  const messageRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (user) {
      messageRef?.current?.focus();
    } else {
      nameRef?.current?.focus();
    }
  }, [user]);

  return (
    <div>
      <div className="sticky top-0 z-20 w-full bg-accent-dark/70 py-2 text-white">
        <h1 className="text-center text-2xl font-bold">Contact</h1>
      </div>
      <div className="flex justify-center">
        {message ? (
          <div className="mb-8 mt-6 bg-white px-6 text-center">
            <h2 className="text-2xl font-bold text-accent-dark">{message}</h2>
          </div>
        ) : (
          <Form replace method="post" className="space-y-6">
            <div className="flex w-[400px] flex-col items-center p-6">
              <div className="mb-8 w-full bg-white p-6">
                <div className="flex flex-col gap-4">
                  <Input
                    type="text"
                    name="name"
                    label="Name"
                    autoComplete="name"
                    required
                    defaultValue={user?.name}
                  />
                  <Input
                    type="email"
                    name="email"
                    label="Email address"
                    defaultValue={user?.email}
                    required={true}
                    pattern="[^@\s]+@[^@\s]+(\.[^@\s]+)+"
                    error={errors.email}
                  />
                  <Input
                    type="textarea"
                    name="message"
                    label="Message"
                    required={true}
                    error={errors.message}
                  />
                </div>
                <div className="mt-2">
                  <span className="text-sm text-red-500">* Required</span>
                </div>
              </div>
              <div>
                <Button type="submit" size="lg" variant="primary">
                  Submit Message
                </Button>
              </div>
              {errors.form && (
                <div className="mt-4 text-sm text-red-600">{errors.form}</div>
              )}
            </div>
          </Form>
        )}
      </div>
      <script src="https://www.google.com/recaptcha/api.js"></script>
    </div>
  );
}
